import { AppState } from "../types";

export const serviceRequestsSelectors = {
  serviceRequestUUID: (state: AppState) => state.serviceRequests.uuid,
  serviceRequests: (state: AppState) => state.serviceRequests.serviceRequests,
  serviceRequestData: (state: AppState) => state.serviceRequests.serviceRequestData,
  serviceRequestDataStatus: (state: AppState) => state.serviceRequests.serviceRequestDataStatus,
};